import React,{ useContext,useEffect,useState } from 'react';
import { AuthContext } from "../../context/AuthContext";
import Appbar from '../../components/Appbar';
import Drawer from '../../components/Drawer';
import Body from '../../components/Body';
import { useDispatch,useSelector } from 'react-redux';
import { pageDetailsApi } from '../../store/cms/getAboutUs';
import { Grid,Stack,Button,Checkbox,FormControlLabel,Modal,Box,Typography,ToggleButton,ToggleButtonGroup,LinearProgress,CircularProgress } from '@mui/material';
import { acceptTermsAndConditionsApi } from '../../store/cms/acceptAdminTermsAndConditions';
import { useNavigate } from 'react-router-dom';

export default function SubAdminTermsAndConditions() {
    const auth = useContext(AuthContext);
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const pageDetails = useSelector((state) => state?.pageDetails);

    const [accepted,setAccepted] = useState(false);
    // const [loading,setLoading] = useState(false);
    const [modalOpen,setModalOpen] = useState(true);
    const [selectedLanguage,setSelectedLanguage] = useState('en');


    const handleLanguageChange = (event,newLanguage) => {

        if (newLanguage === selectedLanguage) return;

        if (newLanguage !== null) {
            setSelectedLanguage(newLanguage);
            if (newLanguage === 'en') {
                dispatch(pageDetailsApi({ name: `channel/channel/admin-terms-and-conditions`,lang: "en" }));
            } else if (newLanguage === 'hi') {
                dispatch(pageDetailsApi({ name: `channel/channel/admin-terms-and-conditions`,lang: "hi" }));
            }
        }

    };

    const handleAcceptTerms = async () => {
        try {
            const response = await dispatch(acceptTermsAndConditionsApi());

            if (response?.payload?.status_code === 200) {
                auth.updateUserData({
                    policy_accepted: true
                });
                setModalOpen(false);
            } else {
                throw new Error('Failed to update terms status');
            }
        } catch (error) {
            console.error('Error updating terms:',error);;
        }
    };

    const handleClose = () => {
        localStorage.clear()
        auth.setIsLogin(false)
        auth.setUserData()
        navigate("/login")
    };

    useEffect(() => {
        dispatch(pageDetailsApi({ name: `channel/channel/admin-terms-and-conditions`,lang: "en" }));
    },[]);

    return (
        <>
            <Appbar />
            <Drawer />
            <Body>
                <Modal
                    open={modalOpen}
                    onClose={handleClose}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    slotProps={{
                        backdrop: {
                            sx: {
                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            }
                        }
                    }}
                    disableEscapeKeyDown={true}
                >
                    <Stack
                        sx={{
                            width: { xs: '98vw',sm: '90vw',md: '70vw',lg: '60vw',xl: '50vw' },
                            maxWidth: 1200,
                            maxHeight: '90vh',
                            bgcolor: '#fff',
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 3,
                            overflow: 'hidden',
                            '&:focus-visible': {
                                outline: 'none',
                            }
                        }}
                    >
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                            <Typography variant="h5" component="h2">
                                {selectedLanguage === 'en' ? 'Terms and Conditions' : 'नियम और शर्तें'}
                            </Typography>

                            <ToggleButtonGroup
                                value={selectedLanguage}
                                exclusive
                                onChange={handleLanguageChange}
                                aria-label="language selection"
                                size="small"
                            >
                                <ToggleButton value="en" aria-label="english">
                                    English
                                </ToggleButton>
                                <ToggleButton value="hi" aria-label="hindi">
                                    हिंदी
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Stack>

                        <Box
                            sx={{
                                overflowY: 'auto',
                                maxHeight: '60vh',
                                marginBottom: 2,
                                paddingRight: 1,
                                '& p': {
                                    marginBottom: 2,
                                    lineHeight: 1.6,
                                },
                                '& blockquote': {
                                    margin: '16px 0',
                                    padding: '16px',
                                    backgroundColor: '#f5f5f5',
                                    // borderLeft: '4px solid #1976d2',
                                    fontStyle: 'italic',
                                },
                                '& ul, & ol': {
                                    marginBottom: 2,
                                    paddingLeft: 3,
                                },
                                '& li': {
                                    marginBottom: 1,
                                    lineHeight: 1.6,
                                },
                                '& ul li': {
                                    listStyleType: 'disc',
                                },
                                '& ol li': {
                                    listStyleType: 'decimal',
                                },
                                '& ul ul li': {
                                    listStyleType: 'circle',
                                },
                                '& ul ul ul li': {
                                    listStyleType: 'square',
                                },
                            }}
                        >
                            {!pageDetails?.loading ? (
                                <div dangerouslySetInnerHTML={{ __html: pageDetails?.result[0]?.content }} />
                            ) : (
                                <Box sx={{ display: 'flex',justifyContent: 'center',alignItems: 'center',height: '50vh' }}>
                                    <CircularProgress />
                                </Box>
                            )}
                        </Box>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={accepted}
                                    onChange={(e) => setAccepted(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label={selectedLanguage === 'en'
                                ? "I have read and accept the terms and conditions"
                                : "मैंने नियम और शर्तों को पढ़ा है और स्वीकार करता हूं"}
                            sx={{ marginBottom: 2 }}
                        />

                        <Stack direction="row" justifyContent="flex-end" spacing={2}>
                            <Button
                                onClick={handleClose}
                                variant="contained"
                                color="primary"
                            >
                                {selectedLanguage === 'en' ? 'Decline' : 'अस्वीकार'}
                            </Button>
                            <Button
                                onClick={handleAcceptTerms}
                                disabled={!accepted}
                                variant="contained"
                                color="primary"
                            >
                                {
                                    (selectedLanguage === 'en' ? 'Accept & Continue' : 'स्वीकार करें और आगे बढ़ें')
                                }
                            </Button>
                        </Stack>
                    </Stack>
                </Modal>
            </Body>
        </>
    );
}